"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRedirectToCanonicalLocale = exports.DUMMY_DEFAULT_LOCALE = void 0;
const theme_kit_core_1 = require("@prezly/theme-kit-core");
const querystring_1 = require("querystring");
const utils_1 = require("../utils");
// We use pseudo locale used for localization testing, to reliably determine if we need to fallback to the default newsroom language
exports.DUMMY_DEFAULT_LOCALE = 'qps-ploc';
function getRedirectToCanonicalLocale(shortestLocaleCode, nextLocaleIsoCode, redirectPath, query) {
    // No need to redirect if no particular locale was requested by the application
    if (!nextLocaleIsoCode || nextLocaleIsoCode === exports.DUMMY_DEFAULT_LOCALE) {
        return undefined;
    }
    const shortestLocaleSlug = shortestLocaleCode
        ? theme_kit_core_1.LocaleObject.fromAnyCode(shortestLocaleCode).toUrlSlug()
        : shortestLocaleCode;
    if (shortestLocaleSlug !== nextLocaleIsoCode) {
        const prefixedPath = redirectPath && !redirectPath.startsWith('/') ? `/${redirectPath}` : redirectPath;
        const finalPath = shortestLocaleSlug
            ? `/${shortestLocaleSlug}${prefixedPath}`
            : prefixedPath;
        const urlQuery = query ? `?${(0, querystring_1.stringify)(query)}` : '';
        return {
            destination: `${(0, utils_1.getResolvedPath)(finalPath)}${urlQuery}`,
            permanent: false,
        };
    }
    return undefined;
}
exports.getRedirectToCanonicalLocale = getRedirectToCanonicalLocale;
//# sourceMappingURL=locale.js.map